import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Own constants/actions/components
import { resSubmitShopping } from 'services/selectors/submit-shopping';
import StepsLineComponent from 'components/steps-line';
import success from 'assets/success.svg';
import cardFail from 'assets/pago-contraentrega.svg';
import ResumenSucces from './resumen-success';

const ConfirmationContainer = () => {
  const response = useSelector(resSubmitShopping);

  return (
    <Container fluid className="bg-white">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <StepsLineComponent itemActive={3} />
          </Col>
        </Row>
        <Row className="justify-content-center py-60">
          <Col lg={9} className="text-center">
            <h2 className="ft-20 text-tangaroa">¡Experiencias adquiridas con éxito!</h2>
            <h3 className="py-30 text-tangaroa ft-18">
              {response.data.message}
            </h3>
            <img src={success} alt="shopping-cart-success" />
            {
              response.data.outOfStockList.length > 0
                ? response.data.outOfStockList.map((itemfail) => {
                  return (
                    <div className="fail-label">
                      <img src={cardFail} alt="fail-card" className="mr-15" />
                      <span className="text-tangaroa">
                        ¡Lo sentimos! La Experiencia:
                        {' '}
                        <b>
                          {itemfail.title}
                        </b>
                        {' '}
                        se ha agotado.
                      </span>
                    </div>
                  );
                })
                : ''
            }
            <div className="d-none d-lg-block d-xl-block">
              <p className="py-30 text-tangaroa ft-16">
                Haz clic en el botón de ‘Salir’ para continuar navegando en el sitio.
              </p>
              <Link to="/" className="btn btn-primary">Salir</Link>
            </div>
          </Col>
          <Col lg={3}>
            <ResumenSucces resumen={response.data.orderSummary} />
          </Col>
          <Col xs={12}>
            <div className="d-lg-none d-xl-none text-center">
              <p className="py-30 text-tangaroa-light ft-16">
                Haz clic en el botón de ‘Salir’ para continuar navegando en el sitio.
              </p>
              <Link to="/" className="btn btn-primary">Salir</Link>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default ConfirmationContainer;
